<palantir-modal>
  <palantir-toolbar palantir-modal-header>
    <palantir-toolbar-main>
      <div class="flex items-center gap-3">
        <palantir-avatar>
          <palantir-icon name="table-edit-outline"></palantir-icon>
        </palantir-avatar>

        <palantir-text type="title" size="lg">Editar tabela</palantir-text>
      </div>
    </palantir-toolbar-main>

    <palantir-toolbar-suffix>
      <palantir-button
        theme="outline"
        size="xs"
        layout="prefix"
        variant="positive"
        icon="download"
        (click)="exportToCSV()"
      >
        Exportar CSV
      </palantir-button>
      <palantir-button
        theme="outline"
        size="xs"
        layout="icon"
        variant="negative"
        icon="close-outline"
        (click)="close()"
      ></palantir-button>
    </palantir-toolbar-suffix>
  </palantir-toolbar>
  <palantir-modal-content class="block h-full">
    <div class="palantir-scrollbar h-full overflow-hidden bg-white p-6">
      <fx-dynamic-tabular
        [control]="data.control"
        [readonly]="data.readonly"
        [schema]="data.schema"
        [hideFullScreen]="true"
      >
      </fx-dynamic-tabular>
    </div>
  </palantir-modal-content>
</palantir-modal>
